import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { liveHolidays } from "@/lib/heroRotation";
import { useSite } from "@/context/SiteContext";
import { Blocks } from "@/components/Blocks";
import { WinnerSpotlight } from "@/components/Giveaway";
import { Spinner } from "@/components/common";
import { useMeta } from "@/hooks/useMeta";

function HolidayIntro({ hol }: { hol: any }) {
  if (!hol || !(hol.text || (hol.cta_label && hol.cta_url))) return null;
  return (
    <div className="max-w-2xl mx-auto text-center px-5 pt-12 md:pt-16" data-testid="home-holiday-intro">
      {hol.text && <p className="font-display text-xl md:text-2xl font-light leading-relaxed text-neutral-700" data-testid="home-holiday-text">{hol.text}</p>}
      {hol.cta_label && hol.cta_url && <Link to={hol.cta_url} className="btn-line inline-block mt-7 px-8 py-3.5 text-xs tracking-[0.25em] uppercase" data-testid="home-holiday-cta">{hol.cta_label}</Link>}
    </div>
  );
}

export default function Home() {
  const { site } = useSite();
  useMeta(site?.seo?.title, site?.seo?.description, site ? { "@context": "https://schema.org", "@type": "JewelryStore", name: site.brand, url: window.location.origin } : null);
  const hol = useMemo(() => liveHolidays(site?.home_holidays)[0], [site?.home_holidays]);
  if (!site) return <Spinner />;
  const blocks = site.home_blocks || [];
  const at = blocks.findIndex((b: any) => b.type === "hero");
  const slides = (hol?.slides || []).filter((s: any) => s.enabled !== false && s.image);
  const hero = at >= 0 && hol && slides.length ? { ...blocks[at], rotation: "random", slides } : blocks[at];
  return (
    <div data-testid="home-page" data-holiday={hol ? hol.key || hol.name : undefined}>
      <Blocks blocks={at >= 0 ? [...blocks.slice(0, at), hero] : []} />
      <HolidayIntro hol={hol} />
      <WinnerSpotlight at="below_hero" />
      <Blocks blocks={blocks.slice(at + 1)} />
      <WinnerSpotlight at="above_instagram" />
    </div>
  );
}
